import { Injectable } from '@angular/core';
import { CnafUserService } from '@cnaf/ng-cnaf-commons';

@Injectable({
  providedIn: 'root'
})

/**
 * Service de traitement de la date
 */
export class UserService {

  constructor(private readonly cnafUserService: CnafUserService) { }

    /**
   * Récupération de l'année à partir de la date d'env. caf
   * @returns annee moins 2 ans : YYYY
   */
  recupererAnneeMoins2AnsYYYY(): number {

    let dateYYYYMMDD = this.cnafUserService.dateEnvCaffr;
    let year = dateYYYYMMDD.substring(0, 4);
    let month = dateYYYYMMDD.substring(4, 6);
    let day = dateYYYYMMDD.substring(6, 8);
    let newDateString = year +"-"+month+"-"+day;
    let dateFormattee = new Date(newDateString);

    return  dateFormattee.getFullYear() - 2;
  }

  /**
   * Récupération de l'année à partir d'une chaine au format YYYYMMDD
   * @param dateEnv YYYYMMDD
   * @returns annee moins 2 ans : YYYY
   */
  recupererAnneeMoins2Ans(dateYYYYMMDD:string ): number {
    let year = dateYYYYMMDD.substring(0, 4);
    let month = dateYYYYMMDD.substring(4, 6);
    let day = dateYYYYMMDD.substring(6, 8);
    let newDateString = year +"-"+month+"-"+day;
    let dateFormattee = new Date(newDateString);

    return  dateFormattee.getFullYear() - 2;
  }
}
